'use client'

import type { ReactNode } from 'react'
import Layout from '@/components/Layout'

/** Every screen in this group gets the top bar and requires sign-in. */
export default function SignedInLayout({ children }: { children: ReactNode }) {
  return <Layout>{children}</Layout>
}
